import axios from 'axios';

const googleTranslate = async function (
  source: string,
  target: string,
  googleApiKey?: string,
): Promise<string> {
  try {
    if (!googleApiKey) {
      throw new Error(
        'Google API key is missing. Please configure your API key.',
      );
    }
    const url = `https://translation.googleapis.com/language/translate/v2?key=${googleApiKey}&q=${source}&target=${target}`;

    let config = {
      method: 'post',
      url: url,
    };

    const response = await axios.request(config);
    const translation = response.data.data.translations[0].translatedText;

    return translation;
  } catch (error: any) {
    throw new Error('Translation error: ' + error.message);
  }
};

export default googleTranslate;
